import React from 'react';
import VerifyEmail from '../Auth/VerifyEmail';

const PortalVerifyEmail: React.FC = () => {
  return <VerifyEmail accountType="portal" />;
};

export default PortalVerifyEmail;
